// removed by extract-text-webpack-plugin
module.exports = {"pbutton":"vuT9AG3F0cgcSdwI2o6Hg","active":"_2YJfCxoHzygQH1kE-LsEj1","leftmost":"_1cVo_aVRUtQtOv-44qMqcg","rightmost":"DwCqvz0fjaQEPT_byHCFT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageControl/index.css
// module id = 844
// module chunks = 0